import React, { useState, useEffect, useRef } from 'react';

function Chat() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [userId] = useState(Date.now().toString());
  const messagesEndRef = useRef(null);

  useEffect(() => {
    // Приветственное сообщение при загрузке компонента
    const welcomeMessage = { sender: 'bot', text: 'Привет! Чем могу помочь?' };
    setMessages([welcomeMessage]);
  }, []);

  useEffect(() => {
    // Скролл к последнему сообщению
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const sendMessage = () => {
    if (input.trim() === '') return;

    // Сообщение пользователя
    const userMessage = { sender: 'user', text: input };
    setMessages(prevMessages => [...prevMessages, userMessage]);

    // Ответ бота
    const botMessage = { sender: 'bot', text: 'Ваше сообщение: "' + input + '" получено.' };
    setMessages(prevMessages => [...prevMessages, botMessage]);

    setInput(''); // Очистка поля ввода после отправки
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      sendMessage();
    }
  };

  return (
    <div className="chat">
      <div className="chat__wrap" style={{ marginBottom: '20px', overflowY: 'auto' }}>
        {messages.map((msg, index) => (
          <div key={index} style={{ textAlign: msg.sender === 'user' ? 'right' : 'left', wordBreak: 'break-word' }}>
            <p className={`chat__msg ${msg.sender}`}>{msg.text}</p>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
      <div className="chat__box">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Введите текст..."
        />
        <button onClick={sendMessage}>
          <svg viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.86624 29.6885C1.66109 30.8388 -0.774701 28.5958 0.236623 26.3477L5.34901 15L0.236624 3.65477C-0.777235 1.40422 1.66109 -0.838815 3.86624 0.311462L27.6032 12.7119C28.0249 12.9323 28.3778 13.2619 28.6239 13.6652C28.87 14.0686 29 14.5305 29 15.0012C29 15.472 28.87 15.9339 28.6239 16.3373C28.3778 16.7406 28.0249 17.0702 27.6032 17.2905L3.86624 29.6885Z" fill="white" />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default Chat;
